"use strict";

var PropTypes = require("prop-types");

var SimpleDropdownFromWizard = require("../commonComponents/SimpleDropdownFromWizard");

class MyRecurringHeaderEditFrequencySelectorComponent extends React.Component {
	render() {
		return (
			<SimpleDropdownFromWizard
				{...this.props}
				thisArg={this}
				hideEmptyOption={!this.props.isDesignMode}
				config={this.props.frequencies} /*Needs to be frequencies because the FrequencyPropertyMap is hard-coded to this*/
				wizard={window.ProjectStore.get("wizardFrequencies")}
				wizardValuesKey="allowedFrequencies"
				configKey="availableFrequencies"
				reactComponentCategory="MyRecurringHeaderEditFrequencySelector"
				reactComponentName="MyRecurringHeaderEditFrequencySelector"
				selectClassName="frequency-selector"
				optionsClassName="availableFrequency"
				selectNameAttribute="frequency"
			/>
		);
	}
}

MyRecurringHeaderEditFrequencySelectorComponent.propTypes = {
	childClass: PropTypes.string,
	context: PropTypes.string,
	dataComponentId: PropTypes.string,
	dataNestedId: PropTypes.string,
	dataRepeatedId: PropTypes.string,
	frequencies: PropTypes.object,
	isCustomTheme: PropTypes.bool,
	isDesignMode: PropTypes.bool,
	reactComponentCategory: PropTypes.string,
	required: PropTypes.bool,
	theme: PropTypes.string
};

module.exports = MyRecurringHeaderEditFrequencySelectorComponent;
